import pagesTheme from 'gatsby-theme-pages/src/layout/theme';
import coreTheme from 'gatsby-theme-core/src/layout/theme';

export default {
  ...pagesTheme,
  blockNav: {
    ...pagesTheme.blockNav,
    linkColor: 'white',
    linkColorHover: coreTheme.primaryColor,
    buttonColor: 'white',
  },
  coverNav: {
    ...pagesTheme.coverNav,
    backgroundColor: coreTheme.grayDarkColor,
    borderColor: coreTheme.grayColor,
    linkColor: 'white',
    buttonColor: 'white',
  },
};
